import React from "react"
import "./Button.scss"

export interface ButtonProps {
  disabled?: boolean,
  onPress(): void,
  labelWithHTML?: string,
}

const Button: React.FC<React.PropsWithChildren<ButtonProps>> = ({ children, disabled, onPress, labelWithHTML }) => {
  const Inner = labelWithHTML
    ? <span dangerouslySetInnerHTML={{__html: labelWithHTML}} />
    : <span>{children}</span>

  if (disabled) {
    return <span className='neo__raffleBtn'>{Inner}</span>
  }
  return <a className='neo__raffleBtn' onClick={onPress}>{Inner}</a>
}

export default Button
